module.exports = __webpack_public_path__ + "static/media/hand-peace.35dff863.svg";